import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { authService } from "./userService";

 
export const subscribeNewsletter = createAsyncThunk(
  "user/subscribeNewsletter",
  async (email, thunkAPI) => {
    try {
      const data = await authService.subscribe(email);
      return data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        "Failed to subscribe to the newsletter";
      console.error("Error subscribing to newsletter:", message);
      return thunkAPI.rejectWithValue({
        message,
        response: error.response
      });
    }
  }
);


 

export const resetState = createAction("Reset_all");

const getCustomerfromLocalStorage = localStorage.getItem("customer")
  ? JSON.parse(localStorage.getItem("customer"))
  : null;
   
   

  const initialState = {
    user: getCustomerfromLocalStorage || null,
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: "",
    isOtpSent: false,
    isOtpResent: false,
    recentlyViewed: [],
    newsletterStatus: null,
    createdUser: null,
    createdAddress: null,
    verifyOtp: null,
    wishlist: [],
    cartProduct: null,
    cartProducts: [],
    deletedCartProduct: null,
    updatedCartProduct: null,
    orderedProduct: null,
    getorderedProduct: [],
    updatedUser: null,
    address: [],
    isLoggedOut: false,
    token: null,
  };
  

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setOtpSent: (state, action) => {
      state.isOtpSent = action.payload;
    },
    resetState: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.message = "";
    }
  
  },
  extraReducers: (builder) => {
    builder
  
  
      .addCase(subscribeNewsletter.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(subscribeNewsletter.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.user = action.payload;
        if (state.isSuccess === true) {
          toast.info("Thank you for subscribing to our newsletter!");
        }
      })
      .addCase(subscribeNewsletter.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload.message;
      
        if (action.payload.response && action.payload.response.data) {
          toast.error(action.payload.response.data.message);
        } else {
          toast.error(action.payload.message);
        }
      })

     
      .addCase(resetState, () => initialState)
  },
});



export default authSlice.reducer;
